import styled, { css } from "styled-components";

interface NavbarMenuProps {
  isOpen: boolean;
}

interface NavbarMenuLinkProps {
  $active?: boolean;
  $variant?: "default" | "logout" | "create";
}

export const Navbar = styled.nav`
  background: var(--navy);
  padding: 0 2rem;
  height: 64px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 12px rgba(17,24,64,0.3);
  position: relative;
  z-index: 100;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
`;

export const NavbarLogo = styled.img`
  height: 38px;
  filter: brightness(0) invert(1);
  display: block;
`;

export const NavbarMenu = styled.ul<NavbarMenuProps>`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 4px;

  @media screen and (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
    flex-direction: column;
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    width: 80%;
    max-width: 320px;
    padding: 1.5rem;
    background: var(--navy-deep, #111840);
    z-index: 200;
    transition: all 0.3s ease-in-out;
    box-shadow: -8px 0 40px rgba(17,24,64,0.3);
    gap: 4px;
  }
`;

export const CloseMenuButton = styled.button`
  font-size: 1.5rem;
  background-color: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  align-self: flex-end;
  margin-bottom: 1rem;

  @media screen and (min-width: 769px) {
    display: none;
  }
`;

export const NavbarMenuItem = styled.li`
  margin: 0;

  a {
    text-decoration: none;
  }

  @media screen and (max-width: 768px) {
    margin: 0;
    width: 100%;
  }
`;

export const NavbarMenuLink = styled.span<NavbarMenuLinkProps>`
  color: rgba(255, 255, 255, 0.65);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: var(--font-body);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 22px 16px;
  display: block;
  cursor: pointer;
  position: relative;

  /* Indicador inferior */
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 3px;
    background: var(--red);
    border-radius: 3px 3px 0 0;
    transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    color: #fff;

    &::after {
      width: 60%;
    }
  }

  /* Estado ativo */
  ${({ $active }) =>
    $active &&
    css`
      color: #fff;

      &::after {
        width: 60%;
      }
    `}

  /* Variante Create */
  ${({ $variant }) =>
    $variant === "create" &&
    css`
      color: #25D366;

      &::after {
        background: #25D366;
      }

      &:hover {
        color: #fff;

        &::after {
          background: #25D366;
        }
      }
    `}

  /* Variante Logout */
  ${({ $variant }) =>
    $variant === "logout" &&
    css`
      color: rgba(255, 255, 255, 0.5);

      &::after {
        background: rgba(255, 255, 255, 0.4);
      }

      &:hover {
        color: var(--red-300);

        &::after {
          background: var(--red);
        }
      }
    `}

  @media screen and (max-width: 768px) {
    padding: 14px 16px;
    font-size: 0.95rem;
    border-bottom: 1px solid rgba(255,255,255,0.06);
    border-radius: 0;

    &::after {
      display: none;
    }

    ${({ $active }) =>
      $active &&
      css`
        background: rgba(255, 255, 255, 0.06);
        border-left: 3px solid var(--red);
        padding-left: 13px;
      `}

    ${({ $variant }) =>
      $variant === "create" &&
      css`
        color: #25D366;
        border-left: 3px solid #25D366;
        padding-left: 13px;
      `}

    ${({ $variant }) =>
      $variant === "logout" &&
      css`
        border-bottom: none;
        margin-top: auto;
        background: rgba(228, 32, 44, 0.08);
        border-radius: var(--radius-sm);
        border-left: none;
        text-align: center;
        color: var(--red-300);
        padding-left: 16px;

        &:hover {
          background: rgba(228, 32, 44, 0.15);
        }
      `}
  }
`;

export const NavbarMenuIcon = styled.button`
  display: none;
  font-size: 1.3rem;
  background-color: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 8px;

  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
